exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myUniverse_buttonGroup{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.myUniverse_buttonGroup button{cursor:pointer}.myUniverse_buttonGroup .mr5{margin-right:5px}.myUniverse_buttonGroup .btn{line-height:1.44;border:1px solid #545a87;border-radius:20px !important;background-color:#ffffff;font-weight:600;letter-spacing:2px;display:inline-table;text-transform:uppercase;padding:6px 12px;font-size:smaller}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/MyUniverse/buttonGroup/ButtonGroup.style.scss
// module id = 1578
// module chunks = 0